// src/pages/Preferences.js
import { Link } from "react-router-dom";
import { UserIcon, HomeIcon, CakeIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

export default function Preferences() {
  return (
    <div className="max-w-md mx-auto mt-10 space-y-6 px-4">
      <h1 className="text-2xl font-semibold">Preference settings</h1>

      <div className="space-y-4">
        <NavItem to="/preferences/about-you" icon={UserIcon} label="About You" />
        <NavItem to="/preferences/your-kitchen" icon={HomeIcon} label="Your Kitchen" />
        <NavItem to="/preferences/your-meals" icon={CakeIcon} label="Your Meals" />
      </div>
    </div>
  );
}

function NavItem({ to, icon: Icon, label }) {
  return (
    <Link
      to={to}
      className="flex items-center justify-between p-4 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
    >
      <div className="flex items-center gap-3">
        <Icon className="h-6 w-6 text-sage" />
        <span className="font-medium">{label}</span>
      </div>
      <ChevronRightIcon className="h-6 w-6 text-sage" />
    </Link>
  );
}
